<template>
  <div class="login-viewport">
    <div class="login-stage" :style="stageStyle">
      <img class="login-bg" src="../../assets/login/login-bg.jpg" alt="">
      <div class="login-card">
        <h1 class="login-title">联想考试系统官网</h1>

        <div class="email-field">
          <span class="email-icon" aria-hidden="true">
            <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
              <rect x="2" y="4" width="16" height="12" rx="1" stroke="#c8c8c8" stroke-width="1.4"/>
              <path d="M2 6L10 11.5L18 6" stroke="#c8c8c8" stroke-width="1.4" stroke-linecap="round"/>
            </svg>
          </span>
          <input
            v-model.trim="email"
            type="text"
            placeholder="请输入邮箱"
            @keydown.enter="onConfirm"
          >
        </div>

        <button type="button" class="btn-confirm" :disabled="confirming" @click="onConfirm">确认</button>

        <div class="action-row">
          <button
            type="button"
            class="btn-secondary"
            :class="{ 'is-active': activeAction === 1 }"
            @click="goRegister"
          >用户未注册，去注册</button>
          <button
            type="button"
            class="btn-secondary"
            :class="{ 'is-active': activeAction === 2 }"
            @click="goLogin"
          >用户已注册，去登陆</button>
        </div>

        <div class="notice-box">
          <img class="notice-icon" src="../../assets/login/notice-icon.png" alt="">
          <p class="notice-text">
            您必须使用服务家园工程师注册LenovoID的邮箱来注册登录，如果注册后仍<br>
            然显示用户未注册，请确认输入的邮箱是否正确，或者邮件联系<span class="highlight">itsupport@lenovo.com</span>解<br>
            决。如果<span class="highlight">itsupport@lenovo.com</span>确认您的LenovoID邮箱无误但仍然无法使用，可以加QQ<br>
            群<span class="highlight">641575730</span>备注员工编号，姓名，部门协助解决。
          </p>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { login, ifGkRegister, loginOut } from '../../assets/js/api.js'
import { clearLoginState } from '../../assets/js/auth.js'
import store from '../../store/index.js'

const MSG_MAP = {
  '201': '登录失败：联想 passport 验证未通过，请重新登录。',
  '202': '登录失败：服务家园不允许该账号登录考试系统。',
  '203': '登录失败：未找到该工程师的基本信息。',
  '204': '登录失败：账号创建或同步失败，请稍后重试。',
  // 注册相关（与 Login.php register() 注释一致）
  '206': '服务家园不存在此账号，请先注册服务家园账号',
  '207': '用户已注册，请及时查看邮箱进行重置密码',
  '208': '注册失败，邮箱发送失败',
  '209': '注册失败，请稍后重试'
}

function getMsgType (msg) {
  if (msg === '207') return 'success'
  if (msg === '201' || msg === '204' || msg === '208' || msg === '209') return 'error'
  return 'warning'
}

const STAGE_W = 1920
const STAGE_H = 1080

function syncLoginState (data) {
  window.sessionStorage.removeItem('headmenu')
  window.localStorage.setItem('username', data.name)
  window.sessionStorage.setItem('type', String(data.type))
  store.commit('setToken', data.token)
}

export default {
  data () {
    return {
      email: '',
      activeAction: null,
      redirectUrl: '',
      confirming: false,
      stageScale: 1
    }
  },
  computed: {
    stageStyle () {
      return { transform: `scale(${this.stageScale})` }
    }
  },
  beforeRouteEnter (to, from, next) {
    const examId = to.query.id
    if (!examId) {
      next()
      return
    }
    store.commit('setToken', '')
    login({ username: '', password: '', yzm: '', type: 2 }).then(res => {
      if (res.data.code === 200) {
        syncLoginState(res.data.data)
        next({ path: '/attention', query: { id: examId } })
      } else {
        next()
      }
    }).catch(() => next())
  },
  mounted () {
    document.body.classList.add('login-page-active')
    this.updateScale()
    window.addEventListener('resize', this.updateScale)

    const { msg, user } = this.$route.query
    if (msg !== '200') {
      clearLoginState()
      loginOut().catch(() => {})
    }
    if (user) this.email = user
    if (msg === '200') {
      this.syncSessionAndGo()
      return
    }
    if (msg && MSG_MAP[msg]) {
      this.showAlert(MSG_MAP[msg], getMsgType(msg))
      this.$router.replace({ path: '/login', query: user ? { user } : {} })
    }
  },
  beforeDestroy () {
    document.body.classList.remove('login-page-active')
    window.removeEventListener('resize', this.updateScale)
  },
  methods: {
    updateScale () {
      this.stageScale = Math.min(window.innerWidth / STAGE_W, window.innerHeight / STAGE_H)
    },
    syncSessionAndGo () {
      login({ username: '', password: '', yzm: '', type: 2 }).then(res => {
        if (res.data.code === 200 && res.data.data) {
          syncLoginState(res.data.data)
          this.$router.replace('/examlists')
        } else {
          this.showAlert(res.data.message || '登录状态同步失败', 'warning')
        }
      }).catch(() => {
        this.showAlert('登录状态同步失败，请重新登录', 'error')
      })
    },
    showAlert (message, type = 'warning') {
      const opts = {
        title: '信息提示',
        content: message,
        closable: true,
        maskClosable: false,
        okText: '关闭'
      }
      if (type === 'error') {
        this.$Modal.error(opts)
      } else if (type === 'success') {
        this.$Modal.success(opts)
      } else {
        this.$Modal.warning(opts)
      }
    },
    onConfirm () {
      if (!this.email) {
        this.showAlert('请输入邮箱！', 'error')
        return
      }
      if (!/^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/.test(this.email)) {
        this.showAlert('邮箱格式错误！', 'error')
        return
      }
      this.confirming = true
      this.activeAction = null
      this.redirectUrl = ''
      ifGkRegister(this.email).then(res => {
        if (res.data.code === 200 && res.data.data) {
          this.redirectUrl = res.data.data.url || ''
          this.activeAction = res.data.data.if_register === 2 ? 2 : 1
        } else {
          this.showAlert(res.data.message || '查询失败', 'warning')
        }
      }).catch(() => {
        this.showAlert('网络异常，请稍后重试', 'error')
      }).finally(() => {
        this.confirming = false
      })
    },
    goRegister () {
      if (this.activeAction === 1 && this.redirectUrl) {
        window.location.href = this.redirectUrl
      }
    },
    goLogin () {
      if (this.activeAction === 2 && this.redirectUrl) {
        clearLoginState()
        const joiner = this.redirectUrl.indexOf('?') > -1 ? '&' : '?'
        window.location.href = this.redirectUrl + joiner + '_t=' + Date.now()
      }
    }
  }
}
</script>

<style scoped>
/*
 * 设计稿 public/登录页面.png — 3840×2160 → 画布 1920×1080
 * 背景：原图等比缩放，不做修改
 * 白框：left 569 top 245，760×530
 */
.login-viewport {
  width: 100vw;
  height: 100vh;
  display: flex;
  align-items: center;
  justify-content: center;
  overflow: hidden;
  background: #fff3e4;
}

.login-stage {
  position: relative;
  width: 1920px;
  height: 1080px;
  flex-shrink: 0;
  transform-origin: center center;
}

.login-bg {
  position: absolute;
  left: 0;
  top: 0;
  width: 1920px;
  height: 1080px;
  display: block;
  pointer-events: none;
  user-select: none;
}

.login-card {
  position: absolute;
  left: 569px;
  top: 245px;
  width: 760px;
  height: 530px;
  box-sizing: border-box;
  background: #ffffff;
  box-shadow: 0 6px 28px rgba(200, 140, 80, 0.18);
  font-family: 'Microsoft YaHei', 'PingFang SC', sans-serif;
}

.login-title {
  position: absolute;
  top: 52px;
  left: 60px;
  right: 60px;
  margin: 0;
  text-align: center;
  font-size: 28px;
  font-weight: 700;
  color: #333333;
  line-height: 1.2;
  letter-spacing: 2px;
}

.email-field {
  position: absolute;
  top: 141px;
  left: 60px;
  width: 640px;
  height: 40px;
  box-sizing: border-box;
  display: flex;
  align-items: center;
  padding: 0 16px;
  border: 1px solid #e3e3e3;
  background: #fff;
}

.email-icon {
  display: flex;
  align-items: center;
  margin-right: 12px;
  flex-shrink: 0;
}

.email-field input {
  flex: 1;
  height: 100%;
  border: none;
  outline: none;
  font-size: 14px;
  color: #333;
  background: transparent;
}

.email-field input::placeholder {
  color: #c0c0c0;
}

.btn-confirm {
  position: absolute;
  top: 202px;
  left: 60px;
  width: 640px;
  height: 38px;
  border: none;
  background: #ff7214;
  color: #fff;
  font-size: 16px;
  letter-spacing: 4px;
  cursor: pointer;
}

.btn-confirm:disabled {
  opacity: 0.75;
  cursor: wait;
}

.action-row {
  position: absolute;
  top: 265px;
  left: 60px;
  width: 640px;
  height: 37px;
  display: flex;
  gap: 16px;
}

.btn-secondary {
  flex: 1;
  height: 37px;
  border: 1px solid #e3e3e3;
  background: #fff;
  color: #666666;
  font-size: 14px;
  cursor: pointer;
  padding: 0 4px;
}

.btn-secondary.is-active {
  border-color: #ff7214;
  background: #ff7214;
  color: #fff;
}

/* 底部提示区：左图标 + 右文案，对标设计稿 */
.notice-box {
  position: absolute;
  top: 339px;
  left: 60px;
  width: 640px;
  height: 126px;
  box-sizing: border-box;
  display: flex;
  flex-direction: row;
  align-items: flex-start;
  padding: 10px 14px 10px 10px;
  border: 1px solid #f6e2d4;
  background: linear-gradient(90deg, #fff6ea 0%, #fffcf7 38%, #ffffff 100%);
}

.notice-icon {
  width: 54px;
  height: auto;
  max-height: 90px;
  margin-right: 10px;
  flex-shrink: 0;
  object-fit: contain;
  object-position: top left;
}

.notice-text {
  flex: 1;
  margin: 0;
  padding-top: 1px;
  font-size: 12px;
  line-height: 20px;
  color: #616161;
  text-align: left;
}

.notice-text .highlight {
  color: #ff7214;
}
</style>

<style>
/* 登录/注册页提示框：居中展示，仅手动关闭 */
body.login-page-active .ivu-modal-wrap {
  display: flex;
  align-items: center;
  justify-content: center;
}
body.login-page-active .ivu-modal-wrap .ivu-modal {
  top: 0;
  margin: 0 auto;
}
</style>



// WEBPACK FOOTER //
// src/pages/login/login.vue